import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Shield, Star, Smartphone, MessageCircleDashed as MessageCircle} from 'lucide-react'

const badges = [
  { icon: Shield, label: "Garantia de satisfação", desc: "Compromisso com o resultado do aluno", color: "#0E8EA0" },
  { icon: Star, label: "Selo de qualidade", desc: "Metodologia reconhecida e validada", color: "#B038B2" },
  { icon: Smartphone, label: "App Store e Google Play", desc: "Disponível nas principais plataformas", color: "#6CC4C4" },
  { icon: MessageCircle, label: "Suporte via WhatsApp", desc: "Atendimento rápido e humanizado", color: "#F5C542" },
]

export default function TrustSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section className="py-20 md:py-28 bg-white">
      <div ref={ref} className="max-w-7xl mx-auto px-5">
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-4">
            Confiança construída com <span style={{ color: "#0E8EA0" }}>resultados</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto">
            A English Work constrói confiança através de tecnologia, consistência e foco na experiência do aluno.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {badges.map((badge, i) => (
            <div
              key={i}
              className={`bg-gray-50 rounded-2xl p-7 text-center border-b-4 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{
                borderBottomColor: badge.color,
                transitionDelay: isVisible ? `${(i + 1) * 120}ms` : "0ms",
              }}
            >
              <div
                className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-5"
                style={{ backgroundColor: `${badge.color}15` }}
              >
                <badge.icon size={28} style={{ color: badge.color }} />
              </div>
              <h3 className="text-gray-900 font-bold text-base mb-2">{badge.label}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{badge.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
